<template>
  <div class="flex flex-row gap-4 p-2">
    <p class="text-darkGray-1 place-self-end font-semibold">Notifikationer</p>
    <!-- <p
      class="text-blue-1 text-xs place-self-end ml-auto cursor-pointer"
      @click="markAllNotificationsAsRead"
    >
      Markera alla som läst
    </p> -->
    <p
      class="text-red-2 text-xs place-self-end cursor-pointer"
      @click="clearAllNotifications"
    >
      Rensa alla
    </p>
  </div>
  <!-- <div class="flex flex-col gap-2">
    <h2 class="text-sm font-bold px-2 pt-2">Idag</h2>
    <ul
      v-if="
      props.notifications.filter((notification: any) => {
        if (moment.unix(notification.timestamp).diff(moment(), 'days') === 0) {
          return notification;
        }
    }).length > 0"
    >
      <li
        v-for="notification in props.notifications.filter((notification: any) => {
        if (moment.unix(notification.timestamp).diff(moment(), 'days') === 0) {
          return notification;
        }
    })"
        :key="notification.id"
      >
        <NotificationItem
          max-message-length="71"
          :notification="notification"
          @delete-notification="deleteNotification"
        />
      </li>
    </ul>
    <p v-else class="text-xs text-gray-500 px-2 pb-2">Inga notifikationer</p>
  </div>
  <div class="flex flex-col gap-2">
    <h2 class="text-sm font-bold px-2 pt-2">Senaste 7 dagarna</h2>
    <ul
      v-if="props.notifications.filter((notification: any) => {
      if (moment(notification.timestamp).diff(moment(), 'days') >= -7 && moment(notification.timestamp).diff(moment(), 'days') < 0) {
        return notification;
      }
    }).length > 0"
    >
      <li
        v-for="notification in props.notifications.filter((notification: any) => {
      if (moment(notification.timestamp).diff(moment(), 'days') >= -7 && moment(notification.timestamp).diff(moment(), 'days') < 0) {
        return notification;
      }
    })"
        :key="notification.id"
      >
        <NotificationItem
          max-message-length="71"
          :notification="notification"
        />
      </li>
    </ul>
    <p v-else class="text-xs text-gray-500 px-2 pb-2">Inga notifikationer</p>
  </div> -->
  <div class="flex flex-col gap-2">
    <!-- <h2 class="text-sm font-bold px-2 pt-2">Notifikationer</h2> -->
    <ul
      v-if="props.notifications.filter((notification: any) => {
        return notifications;
      
      // if (moment(notification.timestamp).diff(moment(), 'days') < -7) {
      //   return notification;
      // }
    }).length > 0"
    >
      <li
        v-for="notification in props.notifications.filter((notification: any) => {
      // if (moment(notification.timestamp).diff(moment(), 'days') < -7) {
        {
        return notification;
      }
    })"
        :key="notification.id"
      >
        <NotificationItem
          max-message-length="71"
          :notification="notification"
        />
      </li>
    </ul>
    <p v-else class="text-xs text-gray-500 px-2 pb-2">Inga notifikationer</p>
  </div>
</template>
<script setup lang="ts">
import { defineProps, computed } from "vue";
import NotificationItem from "./NotificationItem.vue";
import { useStore } from "vuex";
import moment from "moment";
import { INotificationItem } from "../models/Notifications";
import { Container } from "inversify";

const store = useStore();

const props = defineProps<{
  notifications: any;
}>();
const deleteNotification = (message: INotificationItem) => {
  store.dispatch("deleteNotification", message);
};
const markAllNotificationsAsRead = async () => {
  await store.dispatch("markAllAsRead");
};

const clearAllNotifications = async () => {
  const containerId = store.getters.container.id;
  await store.dispatch("deleteAllNotifications", containerId);
};
</script>
